var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"to":"/inbox"}},[_c('feather-icon',{attrs:{"badge":_vm.unreadMessages,"badge-classes":"badge-danger","size":"21","icon":"MessageSquareIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }